export default __webpack_public_path__ + "static/media/testador1.e0761fa2.png";